<template>
    <div class="TTL-el-form-search-regular">
        <el-form inline="true">
            <el-form-item>
                <wccascader
                    :value="param.scateid > 0 ? [param.pcateid,param.scateid] : [param.pcateid]"
                    :list="catelists"
                    :option="{placeholder:'请选择分类',clearable:true,filterable:true}"
                    @finish="(val)=> {
                        console.log(val);
                        param.pcateid=val.pcateid > 0 ? val.pcateid : '';
                        param.scateid=val.scateid > 0 ? val.scateid : '';
                        param.ischange=true;
                        GetVedioList();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcinput :option="{placeholder:'教程名称',clearable:true,ischange:true,isinput:true,iskeydown:true}" 
                    :value="param.key"
                    @finish="(val)=> {
                        if(val.type=='input') {param.key=val.value;param.ischange=true;}
                        if(val.type=='change') {param.key=val.value;param.ischange=true;}
                        if(val.type=='keydown') GetVedioList();
                    }"
                />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'搜索'}" @finish="GetVedioList()" />
            </el-form-item>
            <el-form-item>
                <wcbutton :option="{title:'新增教程'}" 
                    @finish="(val)=>{
                        var navinfo={name:'新增教程',labelentry:'AddPlatFormVideo',components:'AddPlatFormVideo',isshow:false};
                        var data={Method:''};
                        var obj={nav:navinfo,data:data};
                        this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
                    }" 
                />
            </el-form-item>
        </el-form>
    </div>

    <!-- 一级分类 --> 
    <div class="TTL-table top20" id="table-plat-vedio-obj">
        <el-table :data="vediolist" stripe="true" empty-text="" ref="pet" @selection-change="selecttable">
            <template v-slot:empty><el-empty description="暂无数据" /></template>
            <el-table-column type="selection" />
            <el-table-column label="封面" align="center">
                <template #default="scope">
                    <wcimage :value="scope.row.cover" :option="{size:'middle'}" @click="openvideo(scope.row)" style="cursor:pointer" />
                </template>
            </el-table-column>
            <el-table-column label="教程名称" prop="name" align="center" />
            <el-table-column label="所属分类" align="center">
                <template #default="scope">
                    <span>{{scope.row.pcatename}}</span>
                    <span v-if="scope.row.scateid > 0"> / {{scope.row.scatename}}</span>
                </template>
            </el-table-column>
            <el-table-column label="添加时间" prop="inputtime" align="center" />
            <el-table-column label="操作" align="center" fixed="right">
                <template #default="scope">
                    <div class="TTL-btn-list">
                    <wcbutton :option="{title:'编辑'}" @finish="GetVedioInfo(scope.row.id)" />
                    <wcbutton :option="{title:'删除',type:'del'}" @finish="DeleVedio(scope.row.id)" class="left10"/>
                    </div>
                </template>
            </el-table-column>
            <el-table-column label="排序" align="center">
                <template #default="scope">
                    <div class="TTL-sort">
                    <wcinput :value="scope.row.sort" :option="{placeholder:'请填写排序方式',type:'input',width:120,ischange:true}"  
                        @finish="(val)=> {
                            if(val.type=='change') ChangeSort(scope.row.id,val.value);
                        }"
                    />
                    </div>
                </template>
            </el-table-column>
        </el-table>
    </div>

    <!-- 分页 -->
    <div class="TTL-page-box top20">
        <div class="TTL-page-box-in">
            <div class="TTL-select TTL-page-left">
                <wcselect 
                    :list="handleinfos"
                    :option="{placeholder:'请选择操作',ischange:true,isconfim:true}" 
                    @finish="(val)=> {
                        var ids=GetSelectDataIds(); //获取勾选的数据ids
                        if(ids.length==0 && (val.value==1 || val.value==2)) { //没有勾选id
                            $notice({title:'错误提示',type:'warning',message:'请勾选要操作的数据'});

                        }else if(val.value==1) { //批量删除账号
                            ids=ids.join(',');
                            DeleVedio(ids);

                        }else if(val.value==2) { //批量编辑账号
                            ids=ids.join(',');
                            GetVedioInfo(ids);

                        }
                    }"
                />
            </div>
            <wcpage 
                :pagerow="param.row" 
                :p="param.p" 
                :rollpage="param.rollpage"  
                @finish="(val)=> {
                    param.p=val.p;
                    param.rollpage=val.rollpage;
                    GetVedioList();
                }"
            />
        </div>
    </div>


    <wcvideo :view="vedioparam.isopen" :url="vedioparam.url" @finish="vedioparam.isopen=false" />
    

</template>

<script>
import INTERFACE_MODEL_PLAT_VEDIO from '@/Interface/Platsetting/PlatVedio';
export default {
    components:{},
    data() {
        return {
            refobj:'platvedioobj',
            param: {
                pcateid:'',
                scateid:'',
                key:'',
                p:1,
                rollpage:10,
                ischange:false,
                rows:0,
            },
            vediolist:[],
            handlevalue:'',
            handleinfos:[
                {id:1,name:'批量删除账号'},
                {id:2,name:'批量编辑账号'},
            ],
            catelists:[],
            vedioparam: {
                isopen:false,
                url:'',
            }

        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetVedioList();
            this.GetCateAll(); //获取一级分类信息
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //组件已存在，同级兄弟元素调用时产生的操作
                this.GetVedioList();
            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                this.GetVedioList();
            }else {
                this.GetVedioList();
            }
        },


        /** 获取分类信息列表 **/
        GetVedioList() {
            if(this.param.ischange) {
                this.param.p=1;
                this.param.ischange=false;
            }

            //loading等待动画加载
            var obj=document.getElementById("table-plat-vedio-obj");
            this.$loading.openloading(obj);
            INTERFACE_MODEL_PLAT_VEDIO.GET_TUTORIALS_LIST(this.param).then((res) => {
                 if(res.status > 0) return false;
                 this.$loading.closeloading(obj);
                 this.param.rows=res.data.count;
                 this.vediolist=res.data.list;
            });
        },


        /** 获取被勾选中的列表数据 **/
        GetSelectDataIds() {
            var ids=[];
            ids=this.vediolist.map((obj)=> obj.isshow ? obj.id : '');
            ids=ids.filter(element=> element!==null && element!==''); //数据进行去除空值处理
            return ids ? ids : [];
        },


        /** 表格数据选择 **/
        selecttable(val) {
            for(var i=0;i < this.vediolist.length;i++) this.vediolist[i].isshow=false;
            for(var i=0;i < val.length;i++) val[i].isshow=true;
            console.log(this.vediolist);
        },


        /** 删除数据 **/
        DeleVedio(ids) {
            INTERFACE_MODEL_PLAT_VEDIO.DEL_TUTORIALS({ids:ids}).then((res) => {
                 if(res.status > 0) return false;
                 this.ischange=true;
                 this.GetVedioList();
            });
        },


        /** 获取分类数据 **/
        GetVedioInfo(ids) {
            var navinfo={name:'编辑使用教程',labelentry:'EditPlatFormVideo',components:'EditPlatFormVideo',isshow:false};
            var data={Method:'',ids:ids};
            var obj={nav:navinfo,data:data};
            this.$parent.ChildCompententAdd(obj); //打开新窗口进行处理
        },


        /** 修改分类排序 **/
        ChangeSort(id,sort) {
            INTERFACE_MODEL_PLAT_VEDIO.DEL_TUTORIALS_SORT({id:id,sort:sort}).then((res) => {
                 if(res.status > 0) return false;
                 this.param.ischange=true;
                 this.GetVedioList();
            });
        },

        /** 获取一级分类信息大全 **/
        GetCateAll() {
            this.catelists=[];
            this.$method.GET_PLAT_VEDIO_CATE_ALL(true).then((res) => {
                this.parentvediolist=res.pcate;
                this.scatevediolist=res.scate;
                var data={};
                for(var i in res.pcate) {
                    data={value:res.pcate[i].id,label:res.pcate[i].name,children:[]};
                    for(var ii in res.scate) {
                        if(res.pcate[i].id==res.scate[ii].pid) data.children.push({value:res.scate[ii].id,label:res.scate[ii].name});
                    }
                    this.catelists.push(data);
                }
                console.log(this.catelists);
            });
        },

        /** 查看视频 **/
        openvideo(param) {
            this.vedioparam={isopen:true,url:param.url}
        },

    },
}
</script>
<style scoped>
.TTL-btn-list {display: inline-flex;justify-content: center;}
.TTL-sort {display: inline-flex;justify-content: center}
</style>